import { render } from "./varriant-attributes.vue?vue&type=template&id=2e78567d"
import script from "./varriant-attributes.vue?vue&type=script&lang=js"
export * from "./varriant-attributes.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__